import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CAMPAIGN_IDS_WITH_EXPIRATION_DATE: DiToken<number[]> = new DiToken<number[]>(
  'campaignIdsWithExpirationDate',
  {
    factory: () => []
  }
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SUPERIOR_IDS_WITH_EXPIRATION_DATE: DiToken<number[]> = new DiToken<number[]>(
  'superiorIdsWithExpirationDate',
  {
    factory: () => []
  }
);
